import styled, { css } from 'styled-components';

import { Flex, mediaMixin, spaceMixin, Spacer, Tag, Text, token } from '@zillow/constellation';

export const StyledPhotoContainer = styled.div`
  position: relative;
`;

export const StyledInlineSpacer = styled(Spacer)`
  display: inline-block;
`;

export const StyledFlex = styled(Flex as any)`
    ${({ usePointer }) => usePointer && 'cursor: pointer'}};
`;

export const StyledFeedTag = styled(Tag)`
  margin-left: ${spaceMixin('xs')};
`;

export const StyledPhotoOverlay = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  padding: ${spaceMixin('sm')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const StyledAddress = styled(Text)`
  display: inline-block;
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const gridDesktopStyles = css`
  &.grid:not(.grid-size-0) {
    display: -ms-grid;
    display: grid;

    -ms-grid-columns: 25% 25% 25% 25%;
    grid-template-columns: 1fr 1fr 1fr 1fr;

    grid-gap: 2px;

    -ms-grid-rows: 109px 109px;
    grid-template-rows: repeat(2, 109px);

    > div {
      display: block;
      background-color: ${token('colors.gray400')};
      background-position: 50% 50%;
      background-repeat: no-repeat;
      background-size: cover;
    }

    .grid-item0,
    .grid-map {
      height: auto;
      width: auto;
    }

    .grid-item0 ~ .grid-map {
      display: block;
    }

    &.grid-size-5 {
      .grid-item0 {
        grid-area: 1 / 1 / span 2 / span 2;
        -ms-grid-column: 1;
        -ms-grid-column-span: 2;

        -ms-grid-row: 1;
        -ms-grid-row-span: 2;
      }

      .grid-item1 {
        -ms-grid-column: 3;
        -ms-grid-row: 1;
      }

      .grid-map,
      .grid-map4 {
        -ms-grid-column: 4;
        grid-column: 4;
        -ms-grid-row: 1;
        grid-row: 1;
      }

      .grid-item2 {
        -ms-grid-column: 3;
        -ms-grid-row: 2;
      }

      .grid-item3 {
        -ms-grid-column: 4;
        -ms-grid-row: 2;
      }
    }

    &.grid-size-4 {
      .grid-item0 {
        grid-area: 1 / 1 / span 2 / span 2;
        -ms-grid-column: 1;
        -ms-grid-column-span: 2;

        -ms-grid-row: 1;
        -ms-grid-row-span: 2;
      }

      .grid-item1 {
        grid-area: 1 / 3 / span 2 / span 1;
        -ms-grid-column: 3;
        -ms-grid-column-span: 1;

        -ms-grid-row: 1;
        -ms-grid-row-span: 2;
      }

      .grid-map,
      .grid-item3 {
        -ms-grid-column: 4;
        grid-column: 4;
        -ms-grid-column-span: 1;
        -ms-grid-row: 1;
        grid-row: 1;
        -ms-grid-row-span: 1;
      }

      .grid-item2 {
        -ms-grid-column: 4;
        -ms-grid-column-span: 1;
        -ms-grid-row: 2;
        -ms-grid-row-span: 1;
      }
    }

    &.grid-size-3 {
      .grid-item0 {
        grid-area: 1 / 1 / span 2 / span 2;
        -ms-grid-column: 1;
        -ms-grid-column-span: 2;

        -ms-grid-row: 1;
        -ms-grid-row-span: 2;
      }

      .grid-item1 {
        grid-area: 1 / 3 / span 2 / span 1;
        -ms-grid-column: 3;
        -ms-grid-column-span: 1;

        -ms-grid-row: 1;
        -ms-grid-row-span: 2;
      }

      .grid-item2,
      .grid-map {
        grid-area: 1 / 4 / span 2 / span 1;
        -ms-grid-column: 4;
        -ms-grid-column-span: 1;

        -ms-grid-row: 1;
        -ms-grid-row-span: 2;
      }
    }

    &.grid-size-2 {
      .grid-item0 {
        grid-area: 1 / 1 / span 2 / span 2;
        -ms-grid-column: 1;
        -ms-grid-column-span: 2;

        -ms-grid-row: 1;
        -ms-grid-row-span: 2;
      }

      .grid-item1,
      .grid-map {
        grid-area: 1 / 3 / span 2 / span 2;
        -ms-grid-column: 3;
        -ms-grid-column-span: 2;

        -ms-grid-row: 1;
        -ms-grid-row-span: 2;
      }
    }

    &.grid-size-1 {
      .grid-item0,
      .grid-map {
        grid-area: 1 / 1 / span 2 / span 4;
        -ms-grid-column: 1;
        -ms-grid-column-span: 4;

        -ms-grid-row: 1;
        -ms-grid-row-span: 2;
      }
    }

    &.grid-size-0 {
      align-items: center;
      justify-content: center;
      display: flex;
      height: 220px;
      width: 100%;
      background-color: ${token('colors.gray400')};
    }
  }
`;

const gridMobileStyles = css`
  &.grid:not(.grid-size-0) {
    display: block;

    > div {
      display: none;
    }

    .grid-item0,
    .grid-map {
      display: block;
      height: 130px;
      width: 100%;
      background-color: ${token('colors.gray400')};
      background-position: 50% 50%;
      background-repeat: no-repeat;
      background-size: cover;
    }

    .grid-item0 ~ .grid-map {
      display: none;
    }
  }

  &.grid-size-0 {
    height: 130px;
    background-color: ${token('colors.gray400')};
  }
`;
export const StyledPhotoGrid = styled.div`
  ${gridMobileStyles}
  ${mediaMixin('md', gridDesktopStyles)};
`;

export const StyledOverlay = styled.div`
  background-color: ${token('colors.black')};
  position: absolute;
  opacity: 0.3;
  display: block;
  height: 100%;
  width: 100%;
`;
